// Chip de severidade biobot M3 (fiel ao Figma): OK = verde (#dcefdf/#1d5a33) com
// bolinha; Atenção = âmbar (#f7e6c9/#6a4a17) com triângulo.
export function SeverityChip({ severity = 'ok' }: { severity?: 'ok' | 'atencao' }) {
  if (severity === 'atencao') {
    return (
      <span className="inline-flex shrink-0 items-center gap-1.5 rounded-full bg-[#f7e6c9] py-1 pl-2.5 pr-3 text-[0.72rem] font-medium text-[#6a4a17]">
        <svg width="11" height="10" viewBox="0 0 11 10" className="shrink-0" aria-hidden>
          <path d="M5.5 0L11 10H0L5.5 0Z" fill="#6a4a17" />
        </svg>
        Atenção
      </span>
    );
  }
  return (
    <span className="inline-flex shrink-0 items-center gap-1.5 rounded-full bg-[#dcefdf] py-1 pl-2.5 pr-3 text-[0.72rem] font-medium text-[#1d5a33]">
      <span className="size-2.5 rounded-full bg-[#1d5a33]" />
      OK
    </span>
  );
}
